import useUserStore from '@/stores/UserStore';
import { Check, CheckSquare, Loader2, Square, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

const FollowerBulkActions = ({
  isMultiSelectMode,
  selectedCount,
  totalFollowersCount,
  currentPageFollowersCount,
  bulkLoading,
  activeFilter,
  onSelectAll,
  onBulkApprove,
  onBulkReject,
}) => {
  const isDemoAccount = useUserStore((state) => state.isDemoAccount);
  if (!isMultiSelectMode || isDemoAccount) return null;

  return (
    <div className='flex flex-col gap-3 border-t border-border/50 pt-3 sm:flex-row sm:items-center sm:justify-between'>
      <div className='flex items-center gap-3'>
        <Button
          variant='ghost'
          size='sm'
          onClick={onSelectAll}
          className='h-8 px-2'
          disabled={bulkLoading}
        >
          {selectedCount === currentPageFollowersCount ? (
            <CheckSquare className='mr-2 h-4 w-4' />
          ) : (
            <Square className='mr-2 h-4 w-4' />
          )}
          {selectedCount === currentPageFollowersCount
            ? 'Deselect All'
            : 'Select All'}
        </Button>
        {selectedCount > 0 && (
          <span className='text-sm text-muted-foreground'>
            {selectedCount} of {totalFollowersCount} selected
          </span>
        )}
        {selectedCount === 0 && (
          <span className='text-sm text-muted-foreground'>
            {totalFollowersCount} followers
          </span>
        )}
      </div>

      {selectedCount > 0 && (
        <div className='flex gap-2'>
          {/* Show Reject button only if not in "rejected" filter */}
          {activeFilter !== 'rejected' && (
            <Button
              variant='outline'
              size='sm'
              onClick={onBulkReject}
              className='h-8 border-red-500 px-3 text-red-600 hover:border-red-600 hover:bg-red-50 dark:border-red-400 dark:text-red-400 dark:hover:bg-red-950'
              disabled={bulkLoading}
            >
              {bulkLoading === 'reject' ? (
                <Loader2 className='mr-1 h-4 w-4 animate-spin' />
              ) : (
                <X className='mr-1 h-4 w-4' />
              )}
              {bulkLoading === 'reject'
                ? 'Processing...'
                : `Reject Selected (${selectedCount})`}
            </Button>
          )}

          {/* Show Approve button only if not in "approved" filter */}
          {activeFilter !== 'approved' && (
            <Button
              size='sm'
              onClick={onBulkApprove}
              className='h-8 border-green-600 bg-green-600 px-3 text-white hover:bg-green-700'
              disabled={bulkLoading}
            >
              {bulkLoading === 'approve' ? (
                <Loader2 className='mr-1 h-4 w-4 animate-spin' />
              ) : (
                <Check className='mr-1 h-4 w-4' />
              )}
              {bulkLoading === 'approve'
                ? 'Processing...'
                : `Approve Selected (${selectedCount})`}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default FollowerBulkActions;
